import React, { useMemo, useCallback, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { FileUpload } from 'components/FileUpload'
import Loading from 'components/Loading/Loading'
import BulkAssignResults from './BulkAssignResults'
import BulkAssignInstructions from './BulkAssignInstructions'
import BulkAssignResultsTable from './BulkAssignResultsTable'
import { formatUploadResults } from './utils'
import { handleBulkAssignUpload } from 'store/netSuiteAssetManager'
import { AppDispatch } from 'store/types'
import { RootState } from 'types'
import { LICENSE_ASSIGNMENT, INSTRUCTIONS, BROWSE, UPLOAD } from './constants'
import { BulkAssignButton, Instructions, UploadSection } from './styles'

const BulkAssignContainer: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>()

  const [file, setFile] = useState<File | null>(null)
  const [fileName, setFileName] = useState<string>('')

  const { isLoading, uploadResults, error } = useSelector(
    (state: RootState) => state.netSuiteAssetManager.bulkAssign,
  )

  const handleFileChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      const selectedFile = event.target.files?.[0]
      if (selectedFile) {
        setFile(selectedFile)
        setFileName(selectedFile.name)
      }
    },
    [],
  )

  const handleUploadClick = useCallback(() => {
    if (file) {
      dispatch(handleBulkAssignUpload(file))
    }
  }, [dispatch, file])

  const formattedResults = useMemo(
    () => formatUploadResults(uploadResults?.data),
    [uploadResults],
  )

  const hasResults = !!uploadResults || !!error

  return (
    <>
      <Loading isLoading={isLoading} message="Processing file...." />

      <h2>{LICENSE_ASSIGNMENT}</h2>
      <hr />

      <BulkAssignInstructions />

      <Instructions>{INSTRUCTIONS}</Instructions>

      <FileUpload
        disabled={isLoading}
        fileName={fileName || ''}
        key={fileName}
        onFileChange={handleFileChange}
      >
        {BROWSE}
      </FileUpload>

      <UploadSection>
        <div>
          {hasResults && (
            <BulkAssignResults error={error} uploadResults={uploadResults} />
          )}
        </div>
        <div>
          <BulkAssignButton
            color="#002855"
            disabled={!file || isLoading}
            onClick={handleUploadClick}
          >
            {UPLOAD}
          </BulkAssignButton>
        </div>
      </UploadSection>

      <BulkAssignResultsTable formattedResults={formattedResults} />
    </>
  )
}

export default BulkAssignContainer
